'use client'

import Fuse from 'fuse.js'
import { useRouter } from 'next/navigation'
import { useEffect, useState } from 'react'

import { PageSearchApiResponse } from '@/lib/api-connector-strapi-cms/api/page-search/pageSearchApi.types'
import { ArticleSearchDTO } from '@/lib/models/model-types/page-search/pageSearch.types'
import { Input } from '@/lib/ui-kit/components/ui/Input.component'

import { fuseOptions } from './ArticlesSearch.const'
import { ArticlesSearchResults } from './ArticlesSearchResults.component'
import { NoResults } from './NoResults.component'

export const ArticlesSearch = ({
  articlesAll,
  dataPage,
}: {
  articlesAll: ArticleSearchDTO[]
  dataPage: PageSearchApiResponse
}) => {
  const [searchPhrase, setSearchPhrase] = useState('' as string)
  const [results, setResults] = useState(articlesAll as ArticleSearchDTO[])
  const [placeholder, setPlaceholder] = useState('')
  const placeholderText = 'Seearch'

  const fuse = new Fuse(articlesAll, fuseOptions)

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearchPhrase(event.target.value)

    if (event.target.value !== '') {
      const searchResults = fuse.search(event.target.value)

      setResults(searchResults.map((result) => result.item))
    } else {
      setResults(articlesAll)
    }
  }

  const hasResults = results.length > 0

  const handleClick = () => {
    setTimeout(() => {
      window.scrollBy(0, -1)
    }, 100)
  }

  const router = useRouter()

  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        router.back()
      }
    }

    window.addEventListener('keydown', handleKeyDown)
    return () => {
      window.removeEventListener('keydown', handleKeyDown)
    }
  }, [])

  useEffect(() => {
    let i = 0
    const typingEffect = setInterval(() => {
      if (i < placeholderText.length) {
        setPlaceholder(
          (prevPlaceholder) => prevPlaceholder + placeholderText.charAt(i),
        )
        i++
      } else {
        clearInterval(typingEffect)
      }
    }, 50)

    return () => clearInterval(typingEffect)
  }, [])

  return (
    <>
      <Input
        className="heading-xl placeholder:heading-xl mb-10 w-full bg-gray-200 px-6 focus:text-base-dark focus:outline-none xl:mb-12 xl:px-10 xl:pb-10 xl:pt-14 "
        type="text"
        placeholder={placeholder}
        value={searchPhrase}
        autoFocus
        onChange={handleInputChange}
        onClick={handleClick}
      />
      {hasResults && (
        <div className="paragraph-l pb-8 pl-6 xl:pl-10">{`${results.length} results found`}</div>
      )}
      <article>
        {hasResults && <ArticlesSearchResults articlesAll={results} />}
        {!hasResults && <NoResults data={dataPage} />}
      </article>
    </>
  )
}
